import { useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  amount: string
  companyId: string
  isRecurring: boolean
  payerCoversFee: boolean
}

export function useCharityCreate() {
  return useMutation<void, unknown, MutationFnParams>({
    mutationFn: async ({ companyId, amount, payerCoversFee, isRecurring }) => {
      await fetcher(
        "/Transaction/Charity/Create",
        {
          method: "POST",
          body: JSON.stringify({
            amount: {
              value: Math.round(Number(amount) * 100 + Number.EPSILON),
              currencyCode: "USD",
            },
            companyId,
            payerCoversFee,
            isRecurring,
          }),
        },
        {
          useAccessToken: true,
        }
      )
    },
  })
}
